import React, { useEffect, useState } from "react";
import { ProjectMappedSupperDelete, ProjectMappedSupperDetail, ProjectMappedSupplierSettingUpdate, ProjectSupplierList, ProjectSupplierMappedSingle, ProjectSupplierMappedSingleUpdate } from "../../../Api/Project";
import { CCollapse, CButton, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter } from '@coreui/react'
import { urlValidate } from '../../../Common/Regex'
import { SupplierDetail } from "../../../Api/Supplier";
import { SelectPicker } from 'rsuite';

function TabSingleSupplerMapped(props) {
    const supplierList = props?.supplierList
    const reactionTypes = props?.reactionTypes
    const detail = props?.detail
    const [mappedSupplierList, setMappedSupplierList] = useState(props?.mappedSupplierList);
    const showPreScreenFilterTab = props?.showPreScreenFilterTab
    const showSecurityFilterTab = props?.showSecurityFilterTab

    const [sComplete, setSComplete] = useState();
    const [sTerminate, setSTerminate] = useState();
    const [sOverQuota, setSOverQuota] = useState()
    const [sQualityTerm, setSQualityTerm] = useState();
    const [sSurveyClose, setSSurveyClose] = useState()
    const [errorSComplete, setErrorSComplete] = useState();
    const [errorSTerminate, setErrorSTerminate] = useState();
    const [errorSOverQuota, setErrorSOverQuota] = useState()
    const [errorSQualityTerm, setErrorSQualityTerm] = useState();
    const [errorSSurveyClose, setErrorSSurveyClose] = useState()
    const [errorSupplier, setErrorSupplier] = useState();
    const [errorSupplierQuota, setErrorSupplierQuota] = useState();
    const [errorSClickQuota, setErrorSClickQuota] = useState();
    const [errorSCpi, setErrorSCpi] = useState();
    const [errorSRedictionType, setErrorSRedictionType] = useState();
    const [visibleSupplirForm, setVisibleSupplirForm] = useState(false)
    const [supplier, setSupplier] = useState()
    const [supplierQuota, setSupplierQuota] = useState()
    const [sClickQuota, setSClickQuota] = useState()
    const [sCpi, setSCpi] = useState();
    const [sRedictionType, setSRedictionType] = useState(437)
    const [supplierDetail, setSupplierDetail] = useState()
    const [visibleSupplierDetail, setVisibleSupplierDetail] = useState(false)
    const [supplierSingleFormButton, setSupplierSingleFormButton] = useState('Submit')
    const [msg, setMsg] = useState()
    const [optionData, setOptionData] = useState()

    const getSupplierdata = () => {

        const dataitems = [];

        supplierList.forEach(lang => {
            dataitems.push({
                label: `${lang.supplierCode}-${lang.supplierName}`, value: lang.supplierID
            })
        });
        setOptionData(dataitems)

    }
    const handleValueChangeDropdown = (value) => {
        setSupplier(value);
        // Clear error when supplier is selected
        if (value) {
            setErrorSupplier();
        }
    };
    
    useEffect(() => {
        getProjectSupplierList()

    }, [])

    // Update supplier options when supplierList prop changes
    useEffect(() => {
        if (supplierList && supplierList.length > 0) {
            getSupplierdata()
        }
    }, [supplierList])

    const getProjectSupplierList = async () => {
        let res = await ProjectSupplierList({ projectId: detail?.projectDetailID })
        if (res.status === 1) {
            await setMappedSupplierList(res.payload)
        } else {
            setMsg(res?.message)
        }
    }

    const getSupplierDetail = async (supplierId) => {
        let res = await SupplierDetail({ payload: supplierId })
        if (res.status === 1) {
            setSupplierDetail(res.payload[0])
            setVisibleSupplierDetail(true)
        }
    }

    const handleAddSupplierCollapse = () => {
        setSupplier()
        setSupplierQuota()
        setSClickQuota()
        setSCpi()
        setSRedictionType(437) // Set default value instead of undefined
        setSupplierSingleFormButton('Submit')
        setVisibleSupplirForm(false)
        setSComplete()
        setSTerminate()
        setSOverQuota()
        setSQualityTerm()
        setSSurveyClose()
        // Clear all error messages
        setErrorSupplier()
        setErrorSupplierQuota()
        setErrorSClickQuota()
        setErrorSCpi()
        setErrorSRedictionType()
        setErrorSComplete()
        setErrorSTerminate()
        setErrorSOverQuota()
        setErrorSQualityTerm()
        setErrorSSurveyClose()
        // Remove manual DOM manipulation for SelectPicker - using controlled component now
        document.getElementById('supplierQuota').value = '';
        document.getElementById('supplier').value = '';
        document.getElementById('clickQuota').value = '';
        document.getElementById('cpi').value = '';
        // Remove direct DOM manipulation for select element as it conflicts with React state
        // document.getElementById('redirectionType').value = '';
        setVisibleSupplirForm(!visibleSupplirForm)
    }

    const addSupplierSingle = async () => {
        // Clear all error messages first
        setErrorSupplier();
        setErrorSupplierQuota();
        setErrorSClickQuota();
        setErrorSCpi();
        setErrorSRedictionType();
        setErrorSComplete();
        setErrorSTerminate()
        setErrorSOverQuota()
        setErrorSQualityTerm()
        setErrorSSurveyClose()

        let error = false;

        // Validate required fields
        if (!supplier) {
            setErrorSupplier("Please select a supplier");
            error = true;
        }

        // Supplier quota is optional, but validate if provided
        if (supplierQuota != null && String(supplierQuota).trim() !== '' && parseInt(supplierQuota) < 0) {
            setErrorSupplierQuota("Supplier quota cannot be negative");
            error = true;
        }

        // Click quota is optional, but validate if provided  
        if (sClickQuota != null && String(sClickQuota).trim() !== '' && parseInt(sClickQuota) < 0) {
            setErrorSClickQuota("Click quota cannot be negative");
            error = true;
        }

        // CPI is optional, but validate if provided
        if (sCpi != null && String(sCpi).trim() !== '' && parseInt(sCpi) < 0) {
            setErrorSCpi("CPI cannot be negative");
            error = true;
        }

        if (!sRedictionType) {
            setErrorSRedictionType("Please select a redirection type");
            error = true;
        }
        let payload = {
            supplierID: parseInt(supplier),
            supplierQuota: parseInt(supplierQuota) || 0, // Default to 0 if empty or NaN
            clickQuota: parseInt(sClickQuota) || 0, // Default to 0 if empty or NaN
            cpi: parseInt(sCpi) || 0, // Default to 0 if empty or NaN
            redirectionTypeID: parseInt(sRedictionType) || 437 // Default to 437 if parsing fails
        }
        if (parseInt(sRedictionType) === 438) {
            let sCompleteUrl = urlValidate(sComplete);
            let sTerminateUrl = urlValidate(sTerminate);
            let sOverQuotaUrl = urlValidate(sOverQuota);
            let sQualityTermUrl = urlValidate(sQualityTerm);
            let sSurveyCloseUrl = urlValidate(sSurveyClose);

            if (!sComplete) {
                setErrorSComplete("Required")
                error = true;
            } else {
                if (sCompleteUrl === false) {
                    setErrorSComplete("Invalid Format")
                    error = true;
                } else {
                    payload.completeURL = sComplete
                }
            }
            if (!sTerminate) {
                setErrorSTerminate("Required")
                error = true;
            } else {
                if (sTerminateUrl === false) {
                    setErrorSTerminate("Invalid Url")
                    error = true;
                } else {
                    payload.terminateURL = sTerminate
                }

            }
            if (!sOverQuota) {
                setErrorSOverQuota("Required")
                error = true;
            } else {
                if (sOverQuotaUrl === false) {
                    setErrorSOverQuota("Invalid Url")
                    error = true;
                } else {
                    payload.overQuotaURL = sOverQuota
                }

            }
            if (!sQualityTerm) {
                setErrorSQualityTerm("Required")
                error = true;
            } else {
                if (sQualityTermUrl === false) {
                    setErrorSQualityTerm("Invalid Url")
                    error = true;
                } else {
                    payload.qualityTeamURL = sQualityTerm
                }
            }
            if (!sSurveyClose) {
                setErrorSSurveyClose("Required")
                error = true;
            } else {
                if (sSurveyCloseUrl === false) {
                    setErrorSSurveyClose("Invalid Url")
                    error = true;
                } else {
                    payload.surveyClosedURL = sSurveyClose
                }
            }
        }
        if (error) {
            return false;
        }
        let res = await ProjectSupplierMappedSingle({ payload: payload, projectDetailID: detail?.projectDetailID })
        if (res.status === 1) {
            props?.getProjectSupplierList()
            getProjectSupplierList()
            resetAddSupplier()
            setVisibleSupplirForm(false)
        }
    }

    const editSupplier = async (supplierId, projecctDetailId) => {
        // Ensure supplier options are up to date before editing
        getSupplierdata()
        
        let res = await ProjectMappedSupperDetail({ supplierId: supplierId, projecctDetailId: projecctDetailId })
        if (res.status === 1) {
            let data = res.payload[0]
            setSupplierDetail(res.payload[0])
            setSupplier(supplierId)
            setSupplierQuota(data?.quota)
            setSClickQuota(data?.clickQuota)
            setSCpi(data?.cpi)
            setSRedictionType(data?.redirectionTypeID)
            setSupplierSingleFormButton('Update')
            setVisibleSupplirForm(true)
            // Remove manual DOM manipulation - SelectPicker will handle display automatically with value prop
            setSComplete(data?.completeURL != 'null' ? data?.completeURL : '')
            setSTerminate(data?.terminateURL != 'null' ? data?.terminateURL : '')
            setSOverQuota(data?.overQuotaURL != 'null' ? data?.overQuotaURL : '')
            setSQualityTerm(data?.qualityTeamURL != 'null' ? data?.qualityTeamURL : '')
            setSSurveyClose(data?.surveyClosedURL != 'null' ? data?.surveyClosedURL : '')
        }
    }

    const updatemappedSupplier = async () => {
        // Clear all error messages first
        setErrorSupplierQuota();
        setErrorSClickQuota();
        setErrorSCpi();
        setErrorSRedictionType();
        setErrorSComplete();
        setErrorSTerminate()
        setErrorSOverQuota()
        setErrorSQualityTerm()
        setErrorSSurveyClose()
        let error = false;

        // Validate fields (supplier is not editable in update mode)
        // Supplier quota is optional, but validate if provided
        if (supplierQuota != null && String(supplierQuota).trim() !== '' && parseInt(supplierQuota) < 0) {
            setErrorSupplierQuota("Supplier quota cannot be negative");
            error = true;
        }

        // Click quota is optional, but validate if provided  
        if (sClickQuota != null && String(sClickQuota).trim() !== '' && parseInt(sClickQuota) < 0) {
            setErrorSClickQuota("Click quota cannot be negative");
            error = true;
        }

        // CPI is optional, but validate if provided
        if (sCpi != null && String(sCpi).trim() !== '' && parseInt(sCpi) < 0) {
            setErrorSCpi("CPI cannot be negative");
            error = true;
        }

        if (!sRedictionType) {
            setErrorSRedictionType("Please select a redirection type");
            error = true;
        }
        let payload = {
            supplierQuota: parseInt(supplierQuota) || 0, // Default to 0 if empty or NaN
            clickQuota: parseInt(sClickQuota) || 0, // Default to 0 if empty or NaN
            cpi: parseInt(sCpi) || 0, // Default to 0 if empty or NaN
            redirectionTypeID: parseInt(sRedictionType) || 437, // Default to 437 if parsing fails
            postbackURL: null
        }

        if (parseInt(sRedictionType) === 438) {
            let sCompleteUrl = urlValidate(sComplete);
            let sTerminateUrl = urlValidate(sTerminate);
            let sOverQuotaUrl = urlValidate(sOverQuota);
            let sQualityTermUrl = urlValidate(sQualityTerm);
            let sSurveyCloseUrl = urlValidate(sSurveyClose);

            if (!sComplete) {
                setErrorSComplete("Required")
                error = true;
            } else {
                if (sCompleteUrl === false) {
                    setErrorSComplete("Invalid Format")
                    error = true;
                } else {
                    payload.completeURL = sComplete
                }
            }
            if (!sTerminate) {
                setErrorSTerminate("Required")
                error = true;
            } else {
                if (sTerminateUrl === false) {
                    setErrorSTerminate("Invalid Url")
                    error = true;
                } else {
                    payload.terminateURL = sTerminate
                }

            }
            if (!sOverQuota) {
                setErrorSOverQuota("Required")
                error = true;
            } else {
                if (sOverQuotaUrl === false) {
                    setErrorSOverQuota("Invalid Url")
                    error = true;
                } else {
                    payload.overQuotaURL = sOverQuota
                }

            }
            if (!sQualityTerm) {
                setErrorSQualityTerm("Required")
                error = true;
            } else {
                if (sQualityTermUrl === false) {
                    setErrorSQualityTerm("Invalid Url")
                    error = true;
                } else {
                    payload.qualityTeamURL = sQualityTerm
                }
            }
            if (!sSurveyClose) {
                setErrorSSurveyClose("Required")
                error = true;
            } else {
                if (sSurveyCloseUrl === false) {
                    setErrorSSurveyClose("Invalid Url")
                    error = true;
                } else {
                    payload.surveyClosedURL = sSurveyClose
                }
            }
        }
        if (error) {
            return false;
        }
        let res = await ProjectSupplierMappedSingleUpdate({ payload: payload, projectDetailID: supplierDetail?.projectDetailID, supplierDetailId: supplier })
        if (res.status === 1) {
            getProjectSupplierList()
            setSupplierSingleFormButton('Submit')
            setVisibleSupplirForm(false)
        }
    }

    const deleteSupplierRow = async (supplierId, projecctDetailId) => {
        let res = await ProjectMappedSupperDelete({ supplierId: supplierId, projecctDetailId: projecctDetailId })
        if (res.status === 1) {
            getProjectSupplierList()
        }
    }

    const resetAddSupplier = async () => {

        setSupplier()
        setSupplierQuota()
        setSClickQuota()
        setSCpi()
        setSRedictionType(437)
        setSupplierSingleFormButton('Submit')
        setVisibleSupplirForm(false)
        setSComplete()
        setSTerminate()
        setSOverQuota()
        setSQualityTerm()
        setSSurveyClose()
        // Clear all error messages
        setErrorSupplier()
        setErrorSupplierQuota()
        setErrorSClickQuota()
        setErrorSCpi()
        setErrorSRedictionType()
        setErrorSComplete()
        setErrorSTerminate()
        setErrorSOverQuota()
        setErrorSQualityTerm()
        setErrorSSurveyClose()
    }

    const copyText = (e, url, index) => {
        e.preventDefault();
        e.stopPropagation();
        navigator.clipboard.writeText(url);
        if (window.getSelection) {
            window.getSelection().removeAllRanges();
        }

        var supplierUrlBG = document.getElementsByClassName("supplierUrl");
        var len = supplierUrlBG.length;

        for (var i = 0; i < len; i++) {
            if (i === index) {
                supplierUrlBG[i].style.backgroundColor = "#dfdff8";
            } else {
                supplierUrlBG[i].style.backgroundColor = "transparent";
            }
        }

        setTimeout(() => {
            if (supplierUrlBG[index]) {
                supplierUrlBG[index].style.backgroundColor = "transparent";
            }
            if (window.getSelection) {
                window.getSelection().removeAllRanges();
            }
        }, 800);
    }

    const updateSetting = async (e, type, supplierId) => {
        let { checked } = e.target
        let payload = {
            settingType: type,
            settingValue: checked ? 1 : 0
        }
        let res = await ProjectMappedSupplierSettingUpdate({ supplierId: supplierId, projectDetailId: detail?.projectDetailID, payload: payload })
        // Checkboxes are controlled by mappedSupplierList, so on cancel/failure they stay on the saved value
        if (res?.status === 1) {
            setMappedSupplierList((list) => list?.map((row) => row.supplierID === supplierId ? { ...row, [type]: checked ? 1 : 0 } : row))
            getProjectSupplierList()
        }

    }
    return (<>
        <div className="card-body">
            <div>
                <div className='table-responsive'>
                    <table className="table table-striped table-hover table_client ">
                        <thead>
                            <tr className="bg-primary" style={{ color: "white" }}>
                                <th scope="col">Sr.No.</th>
                                <th scope="col">SupplierCode</th>
                                <th scope="col">SupplierName</th>
                                <th scope="col">Quota</th>
                                <th scope="col">ClickQuota</th>
                                <th scope="col">CPI</th>
                                <th scope="col">SupplierProjectId</th>
                                <th scope="col">SupplierUrl</th>
                                <th scope="col">TestLink</th>
                                <th scope="col">AllowTraffic</th>
                                {showPreScreenFilterTab ? (<>
                                    <th>PreScreen</th>
                                </>) : (<></>)}

                                <th scope="col">Security</th>
                                <th scope="col">API</th>
                                <th scope="col">Status	</th>
                                <th scope="col">Action	</th>
                            </tr>
                        </thead>
                        <tbody>
                            {mappedSupplierList?.length > 0 ? (<>
                                {mappedSupplierList?.map((row, i) => {
                                    return (<React.Fragment key={row.supplierID}>
                                        <tr>
                                            <td>{i + 1}</td>
                                            <td>
                                                <span className="clickableText" onClick={() => getSupplierDetail(row.supplierID)}>
                                                    {row.supplierCode}
                                                </span>
                                            </td>
                                            <td>{row.supplierName}</td>
                                            <td>{row.quota}</td>
                                            <td>{row.clickQuota}</td>
                                            <td>{row.cpi}</td>
                                            <td></td>
                                            <td style={{ "textAlign": 'left' }}>
                                                <i className="ri-file-copy-line supplier-url-copy" onClick={(e) => copyText(e, row.supplierUrl, i)} title="Copy text"></i><span className='supplierUrl' id={"supplierUrl" + i}>{row.supplierUrl}</span>
                                            </td>
                                            <td><input className="form-check-input" id={"testLink" + row.supplierID} type="checkbox" checked={Number(row?.testLink) === 1} onChange={(e) => updateSetting(e, 'testLink', row.supplierID)} /></td>
                                            <td><input className="form-check-input" id={"allowTraffic" + row.supplierID} type="checkbox" checked={Number(row?.allowTraffic) === 1} onChange={(e) => updateSetting(e, 'allowTraffic', row.supplierID)} /></td>
                                            {showPreScreenFilterTab ? (<>
                                                <td><input className="form-check-input" id={"prescreen" + row.supplierID} type="checkbox" checked={Number(row?.prescreen) === 1} onChange={(e) => updateSetting(e, 'prescreen', row.supplierID)} /></td>
                                            </>) : (<></>)}

                                            <td><input className="form-check-input" id={"security" + row.supplierID} type="checkbox" disabled={!showSecurityFilterTab} checked={Number(row?.security) === 1} onChange={(e) => updateSetting(e, 'security', row.supplierID)} /></td>
                                            <td><input className="form-check-input" type="checkbox" disabled={true} checked={row?.api === 1 ? true : false} /></td>
                                            <td></td>
                                            <td>
                                                <span className="p-1"><i className="ri-edit-2-line pointerC" onClick={() => editSupplier(row.supplierID, row.projectDetailID)}></i></span>
                                                {/* <span className="p-1"><i className="ri-delete-bin-2-line del pointerC" onClick={() => deleteSupplierRow(row.supplierID, row?.projectDetailID)}></i></span> */}
                                            </td>
                                        </tr>
                                    </React.Fragment>)
                                })}

                            </>) : (<>
                                <tr>
                                    <td colSpan={13}>
                                        <center>{msg}</center>
                                    </td>
                                </tr>
                            </>)}

                        </tbody>
                    </table>
                </div>
            </div>
            <div>
                {mappedSupplierList?.length > 0 ? (<>
                    <button
                        type="button"
                        className="btn btn-link clickableText add-supplier-btn mb-3 mt-5 p-0"
                        onClick={() => { handleAddSupplierCollapse(); getSupplierdata() }}
                        aria-expanded={visibleSupplirForm}
                        aria-controls="supplierForm"
                    >
                        + Add Supplier
                    </button>
                </>) : (<></>)}
                
                <div>
                    <CCollapse visible={visibleSupplirForm}>
                        <div className="row">
                            <div className="col-xl-12 col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="">
                                            <form>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="mb-3">
                                                            <label className="form-label mb-0">Supplier <span className="required_field">*</span></label>
                                                        </div>
                                                        <div className="mb-3" id="supplier">
                                                            <SelectPicker placeholder="Select Supplier" data={optionData}
                                                                id="supplier"
                                                                value={supplier}
                                                                onChange={handleValueChangeDropdown}
                                                                disabled={supplierSingleFormButton === 'Update' ? (true) : (false)}
                                                                block tabIndex={1} />
                                                            {errorSupplier && <div className="required_field">{errorSupplier}</div>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="mb-3">
                                                            <label className="form-label mb-0">Supplier Quota</label>
                                                            <input type="text" id="supplierQuota" className="form-control" placeholder="0" 
                                                                onChange={(e) => {
                                                                    setSupplierQuota(e.target.value);
                                                                    if (e.target.value.trim() !== '') {
                                                                        setErrorSupplierQuota();
                                                                    }
                                                                }} 
                                                                value={supplierQuota != null ? String(supplierQuota) : ''} tabIndex={2} />
                                                            {errorSupplierQuota && <div className="required_field">{errorSupplierQuota}</div>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="mb-3">
                                                            <label className="form-label mb-0">Click Quota</label>
                                                            <input type="text" id="clickQuota" className="form-control" placeholder="0 " value={sClickQuota} 
                                                                onChange={(e) => {
                                                                    setSClickQuota(e.target.value);
                                                                    if (e.target.value.trim() !== '') {
                                                                        setErrorSClickQuota();
                                                                    }
                                                                }} 
                                                                tabIndex={3} />
                                                            {errorSClickQuota && <div className="required_field">{errorSClickQuota}</div>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="mb-3">
                                                            <label className="form-label mb-0">CPI</label>
                                                            <input type="text" id="cpi" className="form-control" placeholder="0" value={sCpi} 
                                                                onChange={(e) => {
                                                                    setSCpi(e.target.value);
                                                                    if (e.target.value.trim() !== '') {
                                                                        setErrorSCpi();
                                                                    }
                                                                }} 
                                                                tabIndex={4} />
                                                            {errorSCpi && <div className="required_field">{errorSCpi}</div>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="mb-3">
                                                            <label className="form-label mb-0">Redirection Type <span className="required_field">*</span></label>
                                                            <select className="form-select" id="redirectionType" value={sRedictionType || 437} 
                                                                onChange={(e) => {
                                                                    setSRedictionType(e.target.value);
                                                                    if (e.target.value) {
                                                                        setErrorSRedictionType();
                                                                    }
                                                                }} 
                                                                tabIndex={5} required>
                                                                <option value={""}>Select Redirection Type</option>
                                                                {reactionTypes?.map((rTypes) => {
                                                                    return (<option key={rTypes.id} value={rTypes.id}>{rTypes.name}</option>)
                                                                })}
                                                            </select>
                                                            {errorSRedictionType && <div className="required_field">{errorSRedictionType}</div>}
                                                        </div>
                                                    </div>
                                                </div>
                                                {sRedictionType?.toString() === '438' ? (<>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <table>
                                                                <tr className='mt-3'>
                                                                    <td>
                                                                        <label className="form-label mb-0">Complete <span className="required_field">*</span></label>
                                                                    </td>
                                                                    <td><input type="url" className="form-control" 
                                                                        onChange={(e) => {
                                                                            setSComplete(e.target.value);
                                                                            if (e.target.value.trim() !== '') {
                                                                                setErrorSComplete();
                                                                            }
                                                                        }} 
                                                                        value={sComplete} tabIndex={6} required />
                                                                        Link eg. https://insightsenabled.mindforceresearch.in/Thanks/Verify?status=c&identifier=[IDENTIFIER]
                                                                        <div className="required_field"> {errorSComplete}</div>
                                                                    </td>
                                                                </tr>
                                                                <br />
                                                                <tr className='mt-3'>
                                                                    <td className='mt-3'>
                                                                        <label className="form-label mb-0">Terminate <span className="required_field">*</span></label>
                                                                    </td>
                                                                    <td className='mt-3'><input type="url" className="form-control" 
                                                                        onChange={(e) => {
                                                                            setSTerminate(e.target.value);
                                                                            if (e.target.value.trim() !== '') {
                                                                                setErrorSTerminate();
                                                                            }
                                                                        }} 
                                                                        value={sTerminate} tabIndex={7} required />
                                                                        Link eg. https://insightsenabled.mindforceresearch.in/Thanks/Verify?status=t&identifier=[IDENTIFIER]
                                                                        <div className="required_field"> {errorSTerminate}</div>
                                                                    </td>
                                                                </tr>
                                                                <br />
                                                                <tr className='mt-3'>
                                                                    <td className='mt-3'>
                                                                        <label className="form-label mb-0">Over Quota <span className="required_field">* </span></label>
                                                                    </td>
                                                                    <td className='mt-3'><input type="url" className="form-control" 
                                                                        onChange={(e) => {
                                                                            setSOverQuota(e.target.value);
                                                                            if (e.target.value.trim() !== '') {
                                                                                setErrorSOverQuota();
                                                                            }
                                                                        }} 
                                                                        value={sOverQuota} tabIndex={8} required />
                                                                        Link eg. https://insightsenabled.mindforceresearch.in/Thanks/Verify?status=q&identifier=[IDENTIFIER]
                                                                        <div className="required_field"> {errorSOverQuota}</div>
                                                                    </td>
                                                                </tr>
                                                                <br />
                                                                <tr className='mt-3'>
                                                                    <td className='mt-3'>
                                                                        <label className="form-label mb-0">Quality Term <span className="required_field">* </span></label>
                                                                    </td>
                                                                    <td className='mt-3'><input type="url" className="form-control" 
                                                                        onChange={(e) => {
                                                                            setSQualityTerm(e.target.value);
                                                                            if (e.target.value.trim() !== '') {
                                                                                setErrorSQualityTerm();
                                                                            }
                                                                        }} 
                                                                        value={sQualityTerm} tabIndex={9} required />
                                                                        Link eg. https://insightsenabled.mindforceresearch.in/Thanks/Verify?status=false&identifier=[IDENTIFIER]
                                                                        <div className="required_field"> {errorSQualityTerm}</div>
                                                                    </td>
                                                                </tr>
                                                                <br />
                                                                <tr className='mt-3'>
                                                                    <td className='mt-3'>
                                                                        <label className="form-label mb-0">Survey Close <span className="required_field">*</span></label>
                                                                    </td>
                                                                    <td className='mt-3'><input type="url" className="form-control" 
                                                                        onChange={(e) => {
                                                                            setSSurveyClose(e.target.value);
                                                                            if (e.target.value.trim() !== '') {
                                                                                setErrorSSurveyClose();
                                                                            }
                                                                        }} 
                                                                        value={sSurveyClose} tabIndex={10} required />
                                                                        Link eg. https://insightsenabled.mindforceresearch.in/Thanks/Verify?status=sc&identifier=[IDENTIFIER]
                                                                        <div className="required_field"> {errorSSurveyClose}</div>
                                                                    </td>
                                                                </tr>
                                                                <br />
                                                            </table>
                                                        </div>
                                                    </div>
                                                </>) : (<></>)}

                                                <div className="row">
                                                    <div className='col-md-9'></div>
                                                    <div className='col-md-3'>

                                                        <div className='mb-3'>
                                                            {supplierSingleFormButton === 'Submit' ? (<>
                                                                <label className="btn btn-primary"htmlFor="Submit" onClick={() => addSupplierSingle()} tabIndex={11}>{supplierSingleFormButton}</label>
                                                                &nbsp;
                                                            </>) : (<>
                                                                <label className="btn btn-primary"htmlFor="Submit" onClick={() => updatemappedSupplier()} tabIndex={11}>{supplierSingleFormButton}</label>
                                                                &nbsp;
                                                            </>)}

                                                            <label className="btn btn-secondary"htmlFor="Cancel" onClick={() => resetAddSupplier()} tabIndex={12}>Cancel</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CCollapse>
                </div>
            </div>
        </div>

        {visibleSupplierDetail ? (<>
            <>
                {/* <CButton onClick={() => setVisibleDetail(!visibleDetail)}>Launch static backdrop modal</CButton> */}
                <CModal visible={visibleSupplierDetail} backdrop={"static"} size={"xl"} onClose={() => setVisibleSupplierDetail(false)}>
                    <CModalHeader style={{ backgroundColor: "#005499", paddingBottom: "10px", margin: "-1px" }} closeButton={false}>
                        <CModalTitle style={{ color: "#fff", width: "100%" }}>
                            Supplier Details
                            <span style={{ float: "right", cursor: "pointer" }} onClick={() => setVisibleSupplierDetail(false)}> X </span>
                        </CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <div className="row mt-2">
                            <div className="col-xl-6 col-lg-6">
                                <table className="GroupProjectDetailTable">
                                    <tr>
                                        <th>Supplier Code <span className="colonSeperator">:</span></th>
                                        <td>{supplierDetail?.code}</td>
                                    </tr>
                                    <tr>
                                        <th>Supplier Name  <span className="colonSeperator">:</span></th>
                                        <td>{supplierDetail?.supplierName}</td>
                                    </tr>
                                    <tr>
                                        <th>Country  <span className="colonSeperator">:</span> </th>
                                        <td>{supplierDetail?.countryName}</td>
                                    </tr>
                                </table>
                            </div>
                            <div className="col-xl-6 col-lg-6">
                                <table className="GroupProjectDetailTable">
                                    <tr>
                                        <th>Contact Number <span className="colonSeperator">:</span></th>
                                        <td>{supplierDetail?.contactNumber}</td>
                                    </tr>
                                    <tr>
                                        <th>Email ID  <span className="colonSeperator">:</span></th>
                                        <td>{supplierDetail?.email}</td>
                                    </tr>
                                    <tr>
                                        <th>Website  <span className="colonSeperator">:</span> </th>
                                        <td>{supplierDetail?.website}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div className="form_divide"><hr ></hr></div>
                        <div className="row mt-2">
                            <div className="col-xl-12 col-lg-12">
                                <h3>Redirect Link for Client</h3>
                            </div>
                            <div className="col-xl-12 col-lg-12">
                                <table className="GroupProjectDetailTable">
                                    <tr>
                                        <th>Complete  <span className="colonSeperator">:</span> </th>
                                        <td>{supplierDetail?.completeURL}</td>
                                    </tr>
                                    <tr>
                                        <th>Terminate  <span className="colonSeperator">:</span> </th>
                                        <td>{supplierDetail?.terminateURL}</td>
                                    </tr>
                                    <tr>
                                        <th>Over Quota  <span className="colonSeperator">:</span> </th>
                                        <td>{supplierDetail?.overQuotaURL}</td>
                                    </tr>
                                    <tr>
                                        <th>Quality Term  <span className="colonSeperator">:</span> </th>
                                        <td>{supplierDetail?.qualityTeamURL}</td>
                                    </tr>
                                    <tr>
                                        <th>Survey Close  <span className="colonSeperator">:</span> </th>
                                        <td>{supplierDetail?.surveyCloseURL}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div className="form_divide"><hr ></hr></div>
                        <div className="row mt-2">
                            <div className="col-xl-12 col-lg-12">

                                <div className="notesWrapper">
                                    <h3>Notes</h3>
                                </div>
                            </div>
                            <div className="col-xl-12 col-lg-12">

                            </div>
                        </div>
                    </CModalBody>
                </CModal>
            </>
        </>) : (<></>)}
    </>)
}

export default TabSingleSupplerMapped